import React from "react";
import { Column } from "devextreme-react/data-grid";
import { LVGridDetalle } from "../../Componentes/Basicos/LVGridDetalle";

class COM_Pagos_Detalle extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      data: [],
      loading: true
    };
  }

  getData = async (IdClave) => {
    // Llama a función asíncrona y maneja los datos
    try {
      const { COM_Pagos_Cabecera: { function_COM_Pagos_Cabecera_Leer } } = require('neftis7_apicaller');
      const resultData = await function_COM_Pagos_Cabecera_Leer(IdClave);
      this.setState({ data: resultData.data, loading: false });
    } catch (error) {
      alert("Error al obtener los datos: " + error);
    }
    this.setState({ loading: false });
  };

  componentDidMount = async () => {
    this.getData(this.props.data.data.IdPago)
  };

  render() {
    return (
      <React.Fragment>
        {this.state.loadingItemsFinancieros ? null : (
          <>
            {this.state.data && this.state.data.ImputacionesFinanciera && this.state.data.ImputacionesFinanciera.length > 0 ? (
              <>
                <LVGridDetalle
                  dataSource={this.state.data.ImputacionesFinanciera}
                  Titulo="Financiero"
                >
                  <Column caption="Código" dataField="IdItem" width="80" alignment="Right" dataType="number" />

                  <Column caption="Cuenta Financiera" alignment="Center">
                    <Column caption="Código" dataField="CodigoCuentaFinanciera" width="70" alignment="Left" dataType="string" />
                    <Column caption="Descripción" dataField="ABM_CON_CuentasFinancieras_Descripcion" width="200" alignment="Left" dataType="string" />
                  </Column>

                  <Column caption="Cheque" alignment="Center">
                    <Column caption="Código" dataField="IdCheque" width="70" alignment="Right" dataType="number" />
                    <Column caption="Número" dataField="Numero" width="200" alignment="Left" dataType="string" />
                  </Column>

                  <Column caption="Moneda" alignment="Center">
                    <Column caption="Código" dataField="CodigoMoneda" width="70" alignment="Left" dataType="string" />
                    <Column caption="Descripción" dataField="ABM_CON_Monedas_Descripcion" width="200" alignment="Left" dataType="string" />
                    <Column caption="Cotización" dataField="Cotizacion" width="70" alignment="Right" dataType="number" format="currency" />
                  </Column>

                  <Column caption="Importe" dataField="Importe" width="100" alignment="Right" dataType="number" format="currency" />
                  <Column caption="Cant.Cuotas" dataField="CantidadCuotas" width="100" alignment="Right" dataType="number" />

                </LVGridDetalle>
              </>
            ) : null}
          </>
        )}

        <br />

        {this.state.loadingImpuestos ? null : (
          <>
            {this.state.data && this.state.data.Impuestos && this.state.data.Impuestos.length > 0 ? (
              <>
                <LVGridDetalle
                  dataSource={this.state.data.Impuestos}
                  Titulo="Impuestos"
                >
                  <Column caption="Código" dataField="IdItem" width="80" alignment="Right" dataType="number" />
                  <Column caption="Impuesto" alignment="Center">
                    <Column caption="Código" dataField="CodigoImpuestoTipo" width="70" alignment="Left" dataType="string" />
                    <Column caption="Descripción" dataField="ABM_IMP_ImpuestosTipos_Descripcion" width="200" alignment="Left" dataType="string" />
                  </Column>
                  <Column caption="Importe" dataField="ImporteImpuesto" width="100" alignment="Right" dataType="number" format="currency" />
                  <Column caption="Porcentaje" dataField="Porcentaje" width="100" alignment="Right" dataType="number" />
                  <Column caption="Comprobante" dataField="Comprobante" width="200" alignment="Left" dataType="string" />
                </LVGridDetalle>
              </>
            ) : null}
          </>
        )}

        <br />

        {this.state.loadingItemsContables ? null : (
          <>
            {this.state.data && this.state.data.ImputacionesContable && this.state.data.ImputacionesContable.length > 0 ? (
              <>
                <LVGridDetalle
                  dataSource={this.state.data.ImputacionesContable}
                  Titulo="Contabilidad"
                >
                  <Column caption="Código" dataField="IdItem" width="80" alignment="Right" dataType="number" />
                  <Column caption="Impuesto" alignment="Center">
                    <Column caption="Código" dataField="CodigoCuentaContable" width="70" alignment="Left" dataType="string" />
                    <Column caption="Descripción" dataField="ABM_CON_CuentasContables_Descripcion" width="200" alignment="Left" dataType="string" />
                  </Column>
                  <Column caption="Importe" dataField="Importe" width="100" alignment="Right" dataType="number" format="currency" />
                  <Column caption="Porcentaje" dataField="Porcentaje" width="100" alignment="Right" dataType="number" />
                </LVGridDetalle>
              </>
            ) : null}
          </>
        )}

        <br />

        {this.state.loadingRelacionesDocsVentaRecibos ? null : (
          <>
            {this.state.data && this.state.data.RelacionesDocsCompraPagos && this.state.data.RelacionesDocsCompraPagos.length > 0 ? (
              <>
                <LVGridDetalle
                  dataSource={this.state.data.RelacionesDocsCompraPagos}
                  Titulo="Relaciones"
                >
                  <Column caption="Código" dataField="IdDocCompra" width="80" alignment="Right" dataType="number" />
                  <Column caption="Doc.Compra" dataField="DocNumeroFantasia" width="120" alignment="Right" dataType="string" />
                  <Column caption="Fecha" dataField="DocFecha" width="100" alignment="Right" dataType="date" format={'dd/MM/yyyy'} filterOperations={['between']} />
                  <Column caption="Imp. Total" dataField="DocImporteTotal" width="200" alignment="Right" dataType="number" format="currency" />
                  <Column caption="Imp. Pagado" dataField="Importe" width="200" alignment="Right" dataType="number" format="currency" />
                </LVGridDetalle>
              </>
            ) : null}
          </>
        )}
      </React.Fragment>
    );
  }
}

export default COM_Pagos_Detalle;
